import { useState, useEffect } from "react";
import {
  collection,
  query,
  orderBy,
  where,
  onSnapshot,
  deleteDoc,
  doc,
  getDoc,
} from "firebase/firestore";
import { db, auth } from "../../firebase";
import { nanoid } from "nanoid";
import AddForm from "./AddForm";
import EditItem from "./EditItem";

import EditForm from "./EditForm";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import DeleteItem from "./DeleteItem";

export default function Monthly(props) {
  const [items, setItems] = useState([]);
  const [isAddMode, setAddMode] = useState(false);
  const [isViewMode, setViewMode] = useState(true);
  const [isEditing, setEditing] = useState(false);
  const [EditID, setEditID] = useState("");

  const month = props.month;

  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    const itemsRef = collection(db, month);
    //console.log("useEffect Monthly", itemsRef);

    try {
      const q = query(
        itemsRef,
        orderBy("created", "desc")
        //where("userUID", "==", user.uid)
      );

      onSnapshot(q, (querySnapshot) => {
        setItems(
          querySnapshot.docs
            //.filter((doc) => doc.data().name === "cc")
            .map((doc) => ({
              id: doc.id,
              title: doc.data().title,
              text: doc.data().text,
            }))
        );
      });
    } catch (error) {
      //console.error(error);
    }
  }, [month]);

  function handleView() {
    setViewMode(true);
    setAddMode(false);
    setEditing(false);
  }

  function handleAdd() {
    setViewMode(false);
    setAddMode(true);
    setEditing(false);
  }

  function handleEdit(action, id) {
    setAddMode(false);
    setViewMode(false);
    setEditID(id);
    setEditing(action);
  }

  const handleDelete = async (id) => {
    //console.log(db.collection(monthRef).doc(id));
    //const res = await db.collection(monthRef).doc(id).delete();
    if (window.confirm("Delete item. Are you sure ?") == true) {
      try {
        await deleteDoc(doc(db, month, id));
      } catch (e) {
        alert(e);
      }
    } else {
    }
  };

  const EditingTemplate = (
    <div className="col-sm-12 text-center">
      <EditForm id={EditID} month={month} handleView={handleView} />
    </div>
  );

  const ViewingTemplate = (
    <div>
      <div class="container">
        <h1>{month}</h1>

        {user && (
          <button
            onClick={() => handleAdd()}
            class="btn btn-primary btn-circle btn-circle-lg m-1"
          >
            <i className="fa fa-search"></i>+
          </button>
        )}

        {items.map((item) => (
          <div className="row justify-content-center" key={"row " + nanoid()}>
            <div className="col-12 text-center " key={"col " + nanoid()}>
              <ul key={"p " + nanoid()}>
                {/* <p key={"p1" + nanoid()}> */}
                <h2 key={"h2" + nanoid()}>
                  {" "}
                  <strong key={"st" + nanoid()}>{item.title} </strong>
                </h2>
                <p key={"p2" + nanoid()}>{item.text}</p>
                {user && (
                  <EditItem
                    idd={item.id}
                    handleEdit={handleEdit}
                    key={"ed" + nanoid()}
                  />
                )}
                {user && (
                  <DeleteItem
                    idd={item.id}
                    handleDelete={handleDelete}
                    key={"del" + nanoid()}
                  />
                )}

                {/* </p> */}
              </ul>
            </div>
          </div>
        ))}
        {/* <img src={require("../assets/broccoli.jpg")} /> */}
      </div>
    </div>
  );

  const AddTemplate = (
    <div>
      <div class="container">
        <h1>{month}</h1>
        <button
          onClick={() => handleView()}
          className="btn btn-danger btn-circle btn-circle-lg m-1"
        >
          <i className="fa fa-search"></i>x
        </button>

        <div className="row justify-content-center">
          <div className="col-12 text-center ">
            <AddForm month={month} handleView={handleView}></AddForm>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {" "}
      {isAddMode ? AddTemplate : <h2></h2>}
      {isViewMode ? ViewingTemplate : <h2></h2>}
      {isEditing ? EditingTemplate : <h2></h2>}
    </>
  );
}
